import type { FindAJobDropdownData } from '#/components/FindAJobDropdown/types/FindAJobDropdownData';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchGetInternshipsRoutePath } from '#/modules/search/internships/routing/searchGetInternshipsRoutePath';
import { searchGetJobsRoutePath } from '#/modules/search/jobs/routing/searchGetJobsRoutePath';
import { searchGetOrgsRoutePath } from '#/modules/search/orgs/routing/searchGetOrgsRoutePath';

export const findAJobDropdownDataPt: FindAJobDropdownData = {
  search: {
    title: 'Busca',
    items: [
      {
        type: 'job',
        title: 'Empregos',
        href: searchGetJobsRoutePath({ locale: I18nLocale.PT }),
      },
      {
        type: 'internship',
        title: 'Estágios',
        href: searchGetInternshipsRoutePath({ locale: I18nLocale.PT }),
      },
      {
        type: 'org',
        title: 'Organizações',
        href: searchGetOrgsRoutePath({ locale: I18nLocale.PT }),
      },
    ],
  },
  resources: {
    title: 'Recursos',
    items: [
      {
        type: 'career-advice',
        title: 'Blog Carreira de Impacto',
        description:
          'Inspirações e dicas para guiar sua jornada profissional no setor social.',
        href: '/pt/carreira-impacto',
      },
    ],
  },
};
